<div [class]="'course-start-dates course-start-dates--' + company | lowercase">
  <div class="course-start-dates__title">{{ title }}</div>
  <ng-container [ngSwitch]="company">
    <lx-price-lists-portal-positively-languages-course-start-dates
      *ngSwitchCase="companyEnum.KIL"
      [courseStartDates]="courseStartDates"
    ></lx-price-lists-portal-positively-languages-course-start-dates>
    <lx-price-lists-portal-alp-course-start-dates
      *ngSwitchCase="companyEnum.ALP"
      [courseStartDates]="courseStartDates"
    ></lx-price-lists-portal-alp-course-start-dates>
  </ng-container>
</div>
